import React from "react";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface SwitchOrderSelectProps {
  rowIndex: number;
  totalItems: number;
  onChangePosition: (nextPosition: string) => void;
}

const SwitchOrderSelect: React.FC<SwitchOrderSelectProps> = ({
  rowIndex,
  totalItems,
  onChangePosition,
}) => (
  <Select
    size="small"
    value={String(rowIndex + 1)}
    onClick={(e) => e.stopPropagation()}
    onChange={(e: SelectChangeEvent<string>) => {
      onChangePosition(e.target.value);
    }}
    sx={{
      width: 50,
      height: 24,
      fontSize: "12px",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#dbe3f0",
      },
      "& .MuiSelect-select": {
        py: "2px",
        px: "4px",
        textAlign: "center",
      },
    }}
  >
    {Array.from({ length: totalItems }, (_, position) => position + 1).map(
      (position) => (
        <MenuItem key={position} value={String(position)}>
          {position}
        </MenuItem>
      ),
    )}
  </Select>
);

export default SwitchOrderSelect;
